<template>
  <b-sidebar
    :visible="isMedicalHistorySidebarActive"
    bg-variant="white"
    title="Medical History"
    class="px-5"
    shadow
    backdrop
    right
    no-header
    @hidden="toggleSidebar()"
  >
    <template #default="{ hide }">
      <div class="mt-2 mb-2 d-flex align-items-center">
        <b-button variant="outline" @click="hide"><feather-icon class="text-primary" icon="XIcon" /></b-button>
        <h4 class="zero-margin">Medical History</h4>
      </div>  
      <div v-for="(consultation, index) in consultationData" :key="index" class="px-3">
        <div>
          <div>
            <p v-if="getValueFromSource(consultation, '_id') === displayedConsultationId">               
              <b-badge
                :variant="'light-danger'"
                class="text-capitalize"
              >
                Currently Viewing
              </b-badge>
            </p>
            <p>Doctor: {{ getValueFromSource(consultation, 'doctor.full_name') }}</p>
            <p>
              Consultation Type: {{ startCase(getValueFromSource(consultation, 'consultation_type')) }}
            </p>
            <p>Date Created: {{ formatDate(getValueFromSource(consultation, 'created')) }}</p>
            <p>Status: 
              <span>
                <b-badge
                pill
                :variant="`light-${resolveStatusVariant(consultation.status)}`"
                class="text-capitalize"
                >
                  {{ getUserStatusText(consultation.status) }}
                </b-badge>
              </span>
            </p>

            <div v-if="getValueFromSource(consultation, 'consultation_type') === 'medical'">
              <p v-if="getValueFromSource(consultation, 'presenting_complaint_history')">
                Presenting Complaint History: {{ startCase(getValueFromSource(consultation, 'presenting_complaint_history')) }}
              </p>
              
              <p v-else>
                There is no complaint history for this consultation.
              </p>
            </div>

            <div class="d-flex align-items-center">
              <b-link
              v-if="can('consultations:CanUpdate')"
              :to="{ name: `admin-${getValueFromSource(consultation, 'consultation_type')}-consultation-edit`, params: { id: getValueFromSource(consultation, 'id') } }"
              class="font-weight-bold d-flex align-items-center"
              >
                <div><feather-icon icon="EditIcon" /></div>
                <div class="align-middle ml-50">Edit</div>
              </b-link>

              <b-link
              v-if="can('consultations:CanView')"
              :to="{ name: `admin-${getValueFromSource(consultation, 'consultation_type')}-consultation-summary`, params: { id: getValueFromSource(consultation, 'id') } }"
              class="font-weight-bold d-flex align-items-center ml-2"
              >
                <div><feather-icon icon="EyeIcon" /></div>
                <div class="align-middle ml-50">View</div>
              </b-link>
            </div>
          </div>
          <hr v-if="((index + 1 ) !== consultationData.length)" class="mt-1" />
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BOverlay,
  BCard,
  BCardHeader,
  BCardBody,
  BDropdown,
  BDropdownItem,
  BBadge,
  BButton,
  BSidebar,
  BRow,
  BCol,
  BCardImg,
  BLink
} from 'bootstrap-vue';
import {
  get,
  startCase
} from "lodash";

import Ripple from 'vue-ripple-directive';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BBadge,
    BSidebar,
    BButton,
    BCardImg,
    BOverlay,
    BCardBody,
    BDropdown,
    BCardHeader,
    BDropdownItem,

  },
  props: {
    patientData: {
      type: Object,
      required: true,
    },
    isMedicalHistorySidebarActive: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
      toggleModal: false,
      consultationData: null,
      displayedConsultationId: null
    }
  },
  created(){
    this.fetchMedicalHistory()
  },
  methods: {
    async fetchMedicalHistory(){
      try {
        this.loading = true;

        const { id } = this.$route.params;
        this.displayedConsultationId = id

        const query = {
          patient_id: this.patientData.id
        }
        this.$router.push({ query }).catch(() => {});

        const request = await this.useJwt().mainService.consultations.list(query);
        const { data } = request.data;
        this.consultationData = data;
      } catch (error){
        this.consultationData = undefined;

        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    toggleSidebar() {
      this.$emit('update:isMedicalHistorySidebarActive', false);
    },
    startCase
  },
}
</script>
